/* eslint-disable @next/next/no-img-element */
import { useEffect, useRef, useState } from 'react';
import Styles from './SearchableDropdown.css';

function SearchableDropdown({
  options,
  label,
  id,
  selectedVal,
  handleChange,
  error,
  completed,
  optionsContainerId,
  handleBlur,
  autoSelect,
  ...props
}) {
  const [query, setQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const inputRef = useRef(null);

  useEffect(() => {
    document.addEventListener('click', toggle);
    return () => document.removeEventListener('click', toggle);
  }, []);

  const selectOption = (option) => {
    setQuery(() => '');
    handleChange(option[label]);
    setIsOpen((isOpen) => !isOpen);
  };

  function toggle(e) {
    setIsOpen(e && e.target === inputRef.current);
  }

  const getDisplayValue = () => {
    if (query) return query;
    if (selectedVal) return selectedVal;

    return '';
  };

  const filter = (options) => {
    return options.filter(
      (option) => option[label].toLowerCase().indexOf(query.toLowerCase()) > -1,
    );
  };

  return (
    <>
      <div className="dropdown">
        <div className="control">
          <div className="selected-value">
            <input
              {...props}
              autoComplete="off"
              ref={inputRef}
              type="text"
              value={getDisplayValue()}
              onChange={(e) => {
                setQuery(e.target.value);
                handleChange('');
              }}
              onBlur={(ev) => {
                if (query) {
                  setQuery('');
                }

                if (typeof handleBlur === 'function') {
                  handleBlur(ev);
                }
              }}
              onClick={toggle}
              placeholder={props.placeholder}
            />
          </div>
          <div className={`arrow ${isOpen ? 'open' : ''}`} />
        </div>

        <div className={`options ${isOpen ? 'open' : ''}`} id={optionsContainerId}>
          {filter(options).map((option, index) => {
            return (
              <div
                onClick={() => selectOption(option)}
                className={`option ${option[label] === selectedVal ? 'selected' : ''}`}
                key={`${id}-${index}`}
              >
                {option[label]}
              </div>
            );
          })}
        </div>
      </div>

      {error && <p className="input-error-text">*{error}</p>}

      <style jsx>{Styles}</style>
    </>
  );
}

export default SearchableDropdown;
